<div class="pagination-content">
  <div class="filtration-table">
    <div class="section-one-filter d-flex align-items-center">
      <div class="per-page-container">
        <span>Showing:</span>
        <p-dropdown
          [(ngModel)]="rowsPerPage"
          (ngModelChange)="handlePaginationChange(true, 1)"
          [ngClass]="'per-page-contract-types'"
          [options]="optionsNumberOFRow"
          appendTo="body"
        ></p-dropdown>
      </div>
      <div class="number-of-records">
        <span>{{ total <= rowsPerPage ? total : rowsPerPage }}</span>
        <span> Out Of </span>
        <span>{{ total }} </span>
        <span><strong>Results</strong></span>
      </div>
    </div>
  </div>
  <div class="pagination-wrapper">
    <div class="page-input">
      <span>Go to</span>
      <input
        class="form-control"
        type="number"
        #pageInput
        (keydown.enter)="setPageManually(+pageInput.value)"
      />
      <button
        class="page-input-btn"
        (click)="setPageManually(+pageInput.value)"
        [disabled]="!pageInput.value"
      >
        <img
          class="search-icon"
          src="../../../../../../../assets/images/icon-search.svg"
          alt="Search icon"
        />
      </button>
    </div>

    <ngb-pagination
      [collectionSize]="total"
      [pageSize]="rowsPerPage"
      [(page)]="currentPage"
      [ellipses]="true"
      [maxSize]="maxSize"
      (pageChange)="handlePaginationChange(true, $event)"
      aria-label="Default pagination"
      class="w-full"
    >
      <ng-template ngbPaginationPrevious
        ><i class="fa-solid fa-angle-left"></i
      ></ng-template>
      <ng-template ngbPaginationNext
        ><i class="fa-solid fa-angle-right"></i
      ></ng-template>
    </ngb-pagination>
  </div>
</div>
